import Icon from '@components/dataDisplay/Icons/Icon';
import { motion } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

const TopDownBtn = styled.div`
  border-radius: var(--buttonBorderRadius);
  background-color: var(--subColor);

  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  transition: background-color 0.2s;

  &:hover {
    cursor: var(--hoverCursorURL), pointer;
    background-color: var(--inkColor);
  }
`;

const TopDownWrap = styled(motion.div)`
  position: fixed;
  bottom: 12px;
  right: 12px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  z-index: 3;
  bottom: 46px;

  @media (max-width: 480px) {
    bottom: 46px;
    right: 6px;
  }
`;

const variants = {
  initial: { opacity: 0, right: -32 },
  show: {
    opacity: 1,
    right: 12,
    transition: {
      ease: [0.6, 0.01, -0.05, 0.95],
      duration: 0.6,
    },
  },
  exit: {
    opacity: 0,
    right: -32,
    transition: {
      duration: 0.2,
    },
  },
};

type Props = {
  show?: boolean;
};

export const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  document.querySelector('body')!.scrollTo({ top: 0, behavior: 'smooth' });

  const editorEl = document.getElementsByClassName('parent-scroll')[0];
  if (editorEl) {
    editorEl.scrollTop = 0;
  }
};

export const scrollDown = (id?: string) => {
  const layoutHeight = document.getElementById(
    id || 'layoutContents',
  )!.clientHeight;

  window.scrollTo({ top: layoutHeight });
  document.querySelector('body')!.scrollTo({ top: layoutHeight });

  const editorEl = document.getElementsByClassName('parent-scroll')[0];
  if (editorEl) {
    const elHeight = editorEl.getBoundingClientRect().height;
    editorEl.scrollTop = elHeight;
  }
};

function BackTopBtn({ show = true }: Props) {
  return (
    <TopDownWrap
      initial="initial"
      animate={show ? 'show' : 'hidden'}
      exit="exit"
      variants={variants}
    >
      <TopDownBtn onClick={scrollTop} style={{ bottom: 86 }} className="top">
        <Icon name="TopArrow20" color="var(--textColor)" />
      </TopDownBtn>

      <TopDownBtn onClick={() => scrollDown()} className="down">
        <Icon name="DownArrow20" color="var(--textColor)" />
      </TopDownBtn>
    </TopDownWrap>
  );
}

export default BackTopBtn;
